import React from "react";

import {SingleSelect} from "sulu-admin-bundle/components";

class EducationList extends React.Component {
    handleOnChange = (value) => {
        this.props.onChange(value);
        this.props.onFinish();
    };

    render() {
        const {dataPath, disabled, error, value} = this.props;

        return (
            <SingleSelect disabled={disabled} value={value} onChange={this.handleOnChange}>
                <SingleSelect.Option disabled>Zuweisung auswählen</SingleSelect.Option>
                <SingleSelect.Option value="1">auf der Baustelle</SingleSelect.Option>
                <SingleSelect.Option value="2">in der Werkstatt</SingleSelect.Option>
                <SingleSelect.Option value="3">im Büro</SingleSelect.Option>
            </SingleSelect>
        );
    }
}

export default EducationList;
